const SITE_ORIGIN = "https://emrkt.co";

export function absoluteUrl(path: string): string {
  if (path.startsWith("http")) return path;
  return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}

export function buildShareIntent(
  network: "linkedin" | "x" | "facebook" | "email",
  opts: { url: string; title?: string; text?: string }
): string {
  const url = encodeURIComponent(opts.url);
  const title = encodeURIComponent(opts.title ?? "");
  const text = encodeURIComponent(opts.text ?? opts.title ?? "");
  switch (network) {
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    case "x":
      return `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    case "email":
      return `mailto:?subject=${title}&body=${text}%0A%0A${url}`;
  }
}

export const NETWORK_LIMITS: Record<string, number> = {
  linkedin: 3000,
  x: 280,
  facebook: 5000,
  instagram: 2200,
  tiktok: 2200,
};

export const NETWORK_LABEL: Record<string, string> = {
  linkedin: "LinkedIn",
  x: "X (Twitter)",
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "TikTok",
};

export const NETWORKS = ["linkedin", "x", "facebook", "instagram", "tiktok"] as const;
export type SocialNetwork = (typeof NETWORKS)[number];

/**
 * Networks whose posting goes through a real API (Phase 2). The rest are
 * "intent" publishers that open a pre-filled compose window or export bundle.
 */
export const API_PUBLISH_NETWORKS: SocialNetwork[] = ["linkedin"];

export function isApiPublish(network: SocialNetwork): boolean {
  return API_PUBLISH_NETWORKS.includes(network);
}